import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";
import { Package } from "../typings";
import { fetchPackagesWithDrill } from "./drills-api";
import MultiSelectField from "../components/MultiSelectField";
import { ApiContextType } from "../api-context";

interface Props {
    id: number;
    open: boolean;
    onClose: () => void;
    onConfirm: (ids: number[]) => void;
    api: ApiContextType;
}

function RemoveFromPackagesDialog({ id, open, onConfirm, onClose, api }: Props) {
    const [packages, setPackages] = useState<Package[]>([]);
    const [packageIds, setPackageIds] = useState<number[]>([]);

    useEffect(() => {
        if (!open) {
            return;
        }
        fetchPackagesWithDrill(api, id)
            .then(setPackages)
            .catch(console.error);
    }, [open, id, api]);

    const onConfirmRemove = () => {
        setPackageIds([]);
        onConfirm(packageIds);
    };

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Remove file from packages
                    </DialogTitle>
                    <MultiSelectField
                        label="Package"
                        placeholder="Select packages"
                        value={packageIds}
                        options={packages.map(item => ({ value: item.id, text: item.name }))}
                        setValue={setPackageIds}
                    />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Remove" onClick={onConfirmRemove} disabled={false} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default RemoveFromPackagesDialog;
